// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__QgPW5","item":"PaymentsMobile_item__1GdT6","label":"PaymentsMobile_label__32aVt","amount":"PaymentsMobile_amount__1PRjH"};